module.exports = __webpack_public_path__ + "img/img21.c6b2fce2.svg";